import hasWhitespaces from "./common/hasWhitespaces";
import incorrectDataType from "./common/incorrectDataType";
import isEmpty from "./common/isEmpty";
import isNull from "./common/isNull";
import isUndefined from "./common/isUndefined";

export const isValidSearchParams = () => {
	let invalidCharsRegex = /[ \[\]{}|\\”%~#<>]/;
	if (invalidCharsRegex.test(window.location.toString())) { 
		return false;
	}
	let url = decodeURI(window.location.search);
	if (
		isNull(url) ||
		isUndefined(url) ||
		incorrectDataType(url, "string") ||
		hasWhitespaces(url) ||
		isEmpty(url) ||
		invalidCharsRegex.test(url)
	) {
		return false;
	} else {
		return true;
	}
};